/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import GetOrderPackage from '../services/GetOrderPackage';
import GetOrderDocumentTypes from '../../order/services/GetOrderDocumentTypes';
import GetOPAttachments from '../services/GetOPAttachments';
import OrderPackageAttachmentsView from '../views/OrderPackageAttachmentsView';

export default async function loadOrderPackageAttachmentsView({ orderPackageID, editable }) {
  const orderPackage = await GetOrderPackage(orderPackageID);
  const [attachments, documentTypes] = await Promise.all([
    GetOPAttachments(orderPackageID),
    GetOrderDocumentTypes(orderPackage.orderFormTypeID)
  ]);

  return new OrderPackageAttachmentsView({
    orderPackageID,
    editable,
    model: new Backbone.Model({
      documentTypes,
      attachments
    })
  });
}
